
export const getTitleAndDescription = (cityIn: string, companyName: string, phone: string) => {
    const cities = ['екатеринбурге', 'перми', 'новосибирске', 'тюмени'];
    const lowerCaseCity = cityIn.toLowerCase();

    if (lowerCaseCity === 'санкт-петербурге') {
         return {
            title: `Подключить домашний интернет в квартире в ${cityIn} | Цены и тарифы на подключение интернета в СПб от Дом.ру`,
            description: `Быстрое подключение к домашнему интернету в Санкт-Петербурге от провайдера Дом.ру.
                             Выгодные тарифы. Высокая бесперебойность и надежность интернет-сети.`,
        };
    }

    if (cities.includes(lowerCaseCity)) {
        return {
            title: `Подключить домашний интернет в квартире в ${cityIn} | Цены и тарифы на подключение интернета от Дом.ру`,
            description: `Быстрое подключение к домашнему интернету в ${cityIn} от провайдера Дом.ру. Выгодные тарифы. Высокая бесперебойность и надежность интернет-сети.`,
        };
    }

    return {
        title: `Подключить интернет от ${companyName} в ${cityIn} | Интернет тарифы`,
        description: `Подключите домашний интернет от официального провайдера ${companyName}. 
                        Проведем скоростной интернет в квартиру по доступной цене в ${cityIn}. Подробнее на сайте или по ☎️ ${phone}`,
    };
};
